import { render, staticRenderFns } from "./MarqueeBanner.vue?vue&type=template&id=1b4909da"
import script from "./MarqueeBanner.vue?vue&type=script&lang=js"
export * from "./MarqueeBanner.vue?vue&type=script&lang=js"
import style0 from "./MarqueeBanner.vue?vue&type=style&index=0&id=1b4909da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports